if (!customElements.get('wlsn-access-form')) {
    class WLSNAccessForm extends HTMLElement {
        constructor() {
            super();

            this.handleSubmit =
                this.handleSubmit.bind(this);
        }

        connectedCallback() {
            this.klaviyoFormId =
                this.dataset.klaviyoFormId;

            this.elements = {
                form: this.querySelector(
                    '.js-wlsn-access-form-form'
                ),

                input: this.querySelector(
                    '.js-wlsn-access-form-input'
                ),

                submit: this.querySelector(
                    '.js-wlsn-access-form-submit'
                ),

                message: this.querySelector(
                    '.js-wlsn-access-form-feedback-message'
                ),
            };

            this.elements.form?.addEventListener(
                'submit',
                this.handleSubmit
            );
        }

        disconnectedCallback() {
            this.elements.form?.removeEventListener(
                'submit',
                this.handleSubmit
            );
        }

        async handleSubmit(e) {
            e.preventDefault();

            const email =
                this.elements.input.value.trim();

            if (!this.isEmail(email)) {
                this.showMessage(
                    'Please enter a valid email address.',
                    'error'
                );

                return;
            }

            this.elements.submit.disabled = true;

            try {
                const response = await fetch(
                    'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
                    {
                        method: 'POST',

                        headers: {
                            accept:
                                'application/json, text/plain, */*',

                            'content-type':
                                'application/x-www-form-urlencoded;charset=UTF-8',
                        },

                        body: new URLSearchParams({
                            g: this.klaviyoFormId,
                            email,
                        }),
                    }
                );

                const data = await response.json();

                if (data.success) {
                    this.classList.add(
                        'successfully-submitted'
                    );
                
                    this.elements.input.value =
                        'You have subscribed successfully!';
                
                    this.elements.input.readOnly = true;
                
                    this.elements.submit.disabled = true;
                
                    return;
                }

                this.showMessage(
                    data.message ||
                        'Something went wrong.',
                    'error'
                );
            } catch (error) {
                console.error(error);

                this.showMessage(
                    'Something went wrong.',
                    'error'
                );
            } finally {
                this.elements.submit.disabled = false;
            }
        }

        showMessage(message, type) {
            if (!this.elements.message) return;

            this.elements.message.textContent =
                message;

            this.elements.message.classList.remove(
                'success',
                'error'
            );

            this.elements.message.classList.add(
                type
            );
        }

        isEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                email
            );
        }
    }

    customElements.define(
        'wlsn-access-form',
        WLSNAccessForm
    );
}